import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const TitleManager = () => {
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname.toLowerCase();

        const staticTitles = {
            "/": "AddMeCart | Bharat’s Shopping portal",
            "/cart": "Cart - AddMeCart",
            "/about-us/": "About Us - AddMeCart",
            "/contact-us/": "Contact Us - AddMeCart",
            "/wishlist": "Your Wishlist - AddMeCart",
            "/checkout": "Checkout - AddMeCart",
            "/profile": "Your Profile - AddMeCart",
            "/my-account/": "Login - AddMeCart",
            "/register": "Register - AddMeCart",
            "/return-policy/": "Return Policy - AddMeCart",
            "/delivery-information/": "Delivery Info - AddMeCart",
            "/shipping-policy/": "Shipping Policy - AddMeCart",
            "/pricing-and-payments-policy/": "Pricing & Payment Policy - AddMeCart",
            "/disclaimer-policy/": "Disclaimer Policy - AddMeCart",
            "/prebooking-terms-and-conditions/": "Prebooking Terms - AddMeCart",
            "/refund-return/": "Refund & Return - AddMeCart",
            "/terms-of-service/": "Terms of Service - AddMeCart",
            "/privacy-policy": "Privacy Policy - AddMeCart",
            "/faq/": "FAQs - AddMeCart",
            "/how-to/": "How to Use - AddMeCart",
            "/track-your-order/": "Track Order - AddMeCart",
            "/thankyoupage": "Thank You - AddMeCart",
            "/topselldetails": "Top Selling Products - AddMeCart",
            "/all-cate": "All Categories - AddMeCart",
            "/allproductdata": "All Products - AddMeCart",
            "/orderplace": "Order Placed - AddMeCart",
            "/showsubcategorydata": "Sub Category - AddMeCart",
            "/shop": "Product Details - AddMeCart",
            "/coupons": "Coupons - AddMeCart",
        };

        let title = staticTitles[path] || "AddMeCart | Bharat's Shopping Portal";

        if (path.startsWith("/product-category/")) {
            const parts = path.split("/");
            const categoryName = parts[2]?.replace(/-/g, " ");
            if (categoryName) {
                title = `Buy ${decodeURIComponent(categoryName)} - From AddMeCart`;
            }
        }

        if (path.startsWith("/showsubcategory/")) {
            const parts = path.split("/");
            const subCategoryName = parts[2]?.replace(/-/g, " ");
            if (subCategoryName) {
                title = `Buy ${decodeURIComponent(subCategoryName)} - From AddMeCart`;
            }
        }

        if (path.startsWith("/product/")) {
            const slug = path.split("/")[2]?.replace(/-/g, " ");
            if (slug) {
                title = `Buy ${decodeURIComponent(slug)} - AddMeCart Online Shopping Cash On Delivery`;
            }
        }

        if (path.startsWith("/category/")) {
            const parts = path.split("/");
            const categoryTitle = parts[3]?.replace(/-/g, " ");
            if (categoryTitle) {
                title = `Buy ${decodeURIComponent(categoryTitle)} - AddMeCart Online Shopping Cash On Delivery`;
            }
        }

        if (path.startsWith("/shop/")) {
            const parts = path.split("/");
            const rawTitle = parts[parts.length - 1];
            const formattedTitle = rawTitle.replace(/-/g, " ");
            title = `Buy ${decodeURIComponent(formattedTitle)} - AddMeCart Online Shopping Cash On Delivery`;
        }
        document.title = title;
    }, [location]);
    return null;
};

export default TitleManager;
